// Project
import request from "../request";
import rawRequest from "../rawRequest";
import { useQuery } from "@tanstack/react-query";

// Start a deployment fo the provided environment.
export const cdkDeploy = async (env, payload) => {
	const response = await request({
		url: `${env}/cdk-deploy/`,
		method: "POST",
		data: {
			...payload,
		},
	});

	return response.data;
};

// Lock or unlock given deployment of an environment.
export const cdkDeploymentLock = async (deployEnvironment, deploymentInfoId, payload) => {
	try {
		const response = await request({
			url: `production/cdk-deploy/${deployEnvironment}/deployment/${deploymentInfoId}/lock`,
			method: "POST",
			data: {
				...payload,
			},
		});
		return response.data;
	} catch (error) {
		if (error.response.status === 422) {
			return error.response.data;
		}
		throw error;
	}
};

// Fetch the status of the latest deployment of an environment.
export const useCdkDeploymentStatus = (deployEnvironment, enabled, interval) =>
	useQuery({
		queryKey: ["cdk-deployment-status", deployEnvironment],
		queryFn: () => rawRequest({ url: `production/cdk-deploy/${deployEnvironment}`, method: "GET" }),
		enabled,
		refetchInterval: interval,
	});

// Fetch the logs of the latest deployment of an environment.
export const useCdkDeploymentLogs = (deployEnvironment, streamName, enabled, interval) =>
	useQuery({
		queryKey: ["cdk-deployment-logs", deployEnvironment, streamName],
		queryFn: () =>
			rawRequest({ url: `production/cdk-deploy/${deployEnvironment}/logs/${streamName}`, method: "GET" }),
		enabled,
		refetchInterval: interval,
	});
